<h3 id="header" class="ui primary header" style="border: none">
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<!-- <div class="ui vertical basic segment" [ngClass]="{ loading: pending }"> -->
<div class="content">
  <div class="ui basic left aligned segment" style="padding: 60px">
    <div [innerHTML]="terms"></div>
    <br />
    <div class="inline" style="padding-top: 60px">
      <button
        class="ui basic primary button"
        (click)="modal.deny(undefined)"
        style="margin-right: 10px"
      >
        I disagree
      </button>
      <button
        class="ui primary button"
        (click)="modal.approve(undefined)"
        autofocus
      >
        I have read and accepted the terms and conditions
      </button>
    </div>
  </div>
</div>
<!-- </div> -->
